import {
  SelectField,
  StringField,
  IntegerField,
} from "@/components/form/InputFields";
import { formField } from "@/components/form/FormField";
import DecimalPropertyInput from "./propertyFields/DecimalPropertyInput";
import DecimalRangeInput from "./propertyFields/DecimalRangeInput.vue";
import { createComponent, createElement as h, ref } from "@vue/composition-api";
import { ZastosowanieCategoryAttribute } from "@megarax/client/src/resources/plm";

interface Props {
  attribute: ZastosowanieCategoryAttribute;
  value: any;
}

const decimalField = formField(DecimalPropertyInput);

export default createComponent<Props>({
  name: "PropertyField",
  props: {
    attribute: { required: true },
    value: { required: true },
  },
  setup(props, ctx) {
    const label =
      props.attribute.label +
      (props.attribute.unit ? ` [${props.attribute.unit}]` : "");
    const name = props.attribute.key;

    const on = ctx.listeners;

    return () => {
      switch (props.attribute.type) {
        case "integer":
          return h(IntegerField, {
            attrs: { value: props.value, label, clearable: true, name },
            on,
          });

        case "string":
          return h(StringField, {
            attrs: { value: props.value, label, name },
            on,
          });

        case "decimal": {
          return h(decimalField, {
            attrs: { value: props.value, label, clearable: true, name },
            props: { value: props.value },
            on,
          });
        }

        case "singleChoice":
          return h(SelectField, {
            attrs: {
              name,
              value: props.value,
              label,
              clearable: true,
              getOptionLabel: (str: string) => str,
              options: props.attribute.choices,
            },
            on,
          });

        case "multipleChoice":
          return h(SelectField, {
            attrs: {
              name,
              value: props.value,
              label,
              getOptionLabel: (str: string) => str,
              options: props.attribute.choices,
              multiple: true,
            },
            on,
          });
        default:
          return h();
      }
    };
  },
});
